/* Copyright (C) Okahu Inc 2023-2024. All rights reserved.*/

import * as go from 'gojs';

import { TOOLTIP_STYLES } from '../graph-config';

export const capitalize = (str:string): string => {
  if (typeof str !== 'string' || str.length === 0) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export type GoMake = typeof go.GraphObject.make;

/**
 * Shared tooltip for agent and tool nodes
 */
export function createNodeToolTip($: GoMake): go.Adornment {
  return $(
    go.Adornment,
    'Auto',
    $(go.Shape, 'RoundedRectangle', {
      fill: TOOLTIP_STYLES.background.fill,
      stroke: TOOLTIP_STYLES.background.stroke,
    }),
    $(
      go.Panel,
      'Vertical',
      {
        defaultAlignment: go.Spot.Left,
        minSize: new go.Size(TOOLTIP_STYLES.minWidth, 0),
      },
      $(
        go.TextBlock,
        {
          margin: TOOLTIP_STYLES.nodeText.margin,
          font: TOOLTIP_STYLES.nodeText.font,
          stroke: TOOLTIP_STYLES.nodeText.stroke,
          wrap: go.Wrap.Fit,
          maxSize: TOOLTIP_STYLES.nodeText.maxSize,
        },
        new go.Binding('text', 'rawType', (t: string) => t && capitalize(t))
      )
    )
  );
}
